
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 84","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.328 40.21c-5.61 1.722-9.39 6.775-9 12.172 1.782-2.1 4.5-3.905 7.813-5.07l1.187-7.102zm-17.362 8.169l-4.949-29.43c-.058-.262.04-.426.04-.426 9.024-5.27 19.235-8.036 29.532-8.036.254 0 .487.012.74.012 2.047-2.215 4.962-3.732 8.066-4.265 2.949-.492 5.956-.738 8.945-.861C55.779 3.076 53.517 1.39 50.803.94A66.76 66.76 0 0039.589 0c-11.99 0-23.813 3.19-34.39 9.362C1.408 11.579-.603 16.16.158 20.77L5.12 50.2c2.227 13.205 21.297 23.294 31.954 23.294.566 0 1.059-.049 1.567-.11-2.11-2.81-4.39-6.644-6.172-11.095-7.453-2.115-16.578-8.48-17.503-13.91zm15.253-22.523c-.125-.689-.36-1.296-.64-1.87-1.29 1.456-3.223 2.584-5.509 3.013-2.284.41-4.492.062-6.172-.86-.078.655-.097 1.311.02 1.988.586 3.567 3.828 5.944 7.227 5.31 3.386-.61 5.683-4.021 5.074-7.581zm64.594-6.004c-13.886-8.1-29.907-11.053-45.61-8.428-4.281.57-7.672 4.302-8.453 8.773L35.781 49.79C33.38 64.083 50.677 81.99 60.516 83.796c9.703 1.825 31.953-8.806 34.36-23.098l4.96-29.445c.774-4.626-1.242-9.203-5.023-11.401zM52.11 35.732c.605-3.569 3.846-5.947 7.245-5.31 3.398.614 5.664 4.017 5.078 7.565-.117.677-.352 1.291-.645 1.886-1.288-1.476-3.221-2.583-5.507-3.013-2.305-.43-4.492-.062-6.172.84-.218-.64-.093-1.296 0-1.969zm10.875 32.594c-8.691-1.62-14.608-9.716-13.905-18.389 3.222 4.205 8.789 7.586 15.545 8.837 6.758 1.251 13.085.062 17.485-2.726-2.079 8.374-10.282 13.886-19.125 12.278zM83.5 43.506c-1.289-1.455-3.242-2.583-5.526-3.013-2.285-.41-4.472-.061-6.172.861-.078-.656-.098-1.312.02-1.988.605-3.568 3.846-5.946 7.245-5.31 3.398.636 5.664 4.018 5.058 7.586-.125.667-.36 1.29-.625 1.865z","fill":"currentColor"}})])
          )
        }
      }
    